import React, { useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { CheckCircle2, Mail, ArrowRight, QrCode, FileText, CreditCard } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

// Mapeamento de valores dos planos
const PLANOS_VALORES = {
  'Básico': 109.00,
  'Profissional': 149.00,
  'Enterprise': 179.00
};

const CheckoutSucesso = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email, plano, ciclo, valor, paymentInfo } = location.state || {};

  // Disparar evento purchase no GTM quando a página carregar
  useEffect(() => {
    if (email && plano && window.dataLayer) {
      const valorPlano = valor || PLANOS_VALORES[plano] || 109.00;
      
      window.dataLayer.push({
        'event': 'purchase',
        'plan': plano?.toLowerCase()?.replace(/\s+/g, '_') || 'basico',
        'value': valorPlano,
        'currency': 'BRL',
        'billing_cycle': ciclo || 'monthly'
      });
      
      console.log('[GTM] Evento purchase disparado:', { plano, valor: valorPlano, ciclo });
    }
  }, [email, plano, ciclo, valor]);

  // Se não tiver state, redirecionar para home
  if (!email) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-teal-50 flex items-center justify-center p-4">
        <Card className="max-w-md w-full text-center p-8">
          <p className="text-slate-600 mb-4">Página não encontrada</p>
          <Button onClick={() => navigate("/")}>Voltar ao Início</Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-teal-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full">
        <CardContent className="pt-8 pb-8 text-center">
          {/* Ícone de Sucesso */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-green-600" />
          </div>

          <h1 className="text-2xl font-bold text-slate-800 mb-2">
            Cadastro Realizado com Sucesso!
          </h1>
          
          <p className="text-slate-600 mb-6">
            Sua assinatura do plano <strong>{plano}</strong> foi criada.
          </p>

          {/* Instruções de Pagamento */}
          {paymentInfo && (
            <div className="bg-slate-50 rounded-lg p-4 mb-6 text-left">
              <h3 className="font-semibold text-slate-700 mb-3 flex items-center gap-2">
                {paymentInfo.billingType === "PIX" && <QrCode className="w-5 h-5" />}
                {paymentInfo.billingType === "BOLETO" && <FileText className="w-5 h-5" />}
                {paymentInfo.billingType === "CREDIT_CARD" && <CreditCard className="w-5 h-5" />}
                Próximos Passos
              </h3>
              
              {paymentInfo.billingType === "PIX" && (
                <div className="space-y-2 text-sm text-slate-600">
                  <p>1. Você receberá um email com o QR Code PIX</p>
                  <p>2. Escaneie o código e realize o pagamento</p>
                  <p>3. Seu acesso será liberado em minutos</p>
                </div>
              )}
              
              {paymentInfo.billingType === "BOLETO" && (
                <div className="space-y-2 text-sm text-slate-600">
                  <p>1. Você receberá um email com o boleto</p>
                  <p>2. Pague até a data de vencimento</p>
                  <p>3. Seu acesso será liberado em até 3 dias úteis</p>
                </div>
              )}
              
              {paymentInfo.billingType === "CREDIT_CARD" && (
                <div className="space-y-2 text-sm text-slate-600">
                  <p>1. O pagamento está sendo processado</p>
                  <p>2. Você receberá a confirmação por email</p>
                  <p>3. Seu acesso será liberado imediatamente</p>
                </div>
              )}
            </div>
          )}

          {/* Email enviado */}
          <div className="flex items-center justify-center gap-2 text-slate-600 mb-6">
            <Mail className="w-5 h-5" />
            <span>Enviamos os detalhes para <strong>{email}</strong></span>
          </div>

          {/* Botão de Login */}
          <Button 
            className="w-full bg-teal-600 hover:bg-teal-700 h-12"
            onClick={() => navigate("/login")}
          >
            Fazer Login
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>

          <p className="text-xs text-slate-500 mt-4">
            Você já pode fazer login. Seu acesso completo será liberado após a confirmação do pagamento.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutSucesso;
